<div class="input-password">
  <input
    [type]="type"
    class="input-mg-app"
    placeholder="{{ placeholder }}"
    [disabled]="disabled"
    (input)="onInput($event)"
    [value]="value"
    autocomplete="off"
  />
  <img
    src="https://s3.amazonaws.com/cdn.mango-soft.com/mango-core/icon-eye.svg"
    class="icon-password"
    (click)="changeMode()"
    *ngIf="type === 'password'"
  />
  <img
    src="https://s3.amazonaws.com/cdn.mango-soft.com/mango-core/icon-eye-show.svg"
    class="icon-password"
    (click)="changeMode()"
    *ngIf="type == 'text'"
  />
</div>
